import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {Studente} from "../shared/interfaces/studente-figlio.interface";

/**
 * Ponte di selezione studente. Storicamente era anche la sorgente di discovery dei figli
 * (anagrafiche da `LocalStorageService`), ma quell'asse è morto: l'area mensa usa ora
 * `StudentiMensaService` come sorgente unica e `user-session.service.ts` scrive sempre
 * `setAnagrafiche$([])`. Qui sopravvive solo il ponte di selezione
 * (`currentStudente`/`setCurrentStudente`/`checkCurrentStudente$`) letto dai consumatori
 * legacy (calendario, profilo-figli, command-palette) e la persistenza dell'id selezionato.
 */
@Injectable({
  providedIn: 'root'
})
export class GlobalManagerFigliService {
  private readonly _checkCurrentStudente$ = new BehaviorSubject(this.getCurrentStudente());
  readonly checkCurrentStudente$: Observable<Studente | undefined> = this._checkCurrentStudente$.asObservable();
  currentStudente: Studente | undefined;
  private static LS_KEY = 'LS_KEY';

  getCurrentStudente() {
    return this.currentStudente
  }

  setCurrentStudente(Studente: Studente | undefined) {
    this.currentStudente = Studente;
    this._checkCurrentStudente$.next(Studente)
    if (Studente?.id) {
      this.saveCurrentStudenteId(Studente.id);
    }
  }

  private saveCurrentStudenteId(id: string | undefined) {
    if(id){
      localStorage.setItem(GlobalManagerFigliService.LS_KEY, id);

    }
  }

  removeSavedStudenteId() {
    try {
      localStorage.removeItem(GlobalManagerFigliService.LS_KEY);
    } catch {
    }
  }
}
